import { render, staticRenderFns } from "./gpeaHelp.vue?vue&type=template&id=0b4c0837&"
import script from "./gpeaHelp.vue?vue&type=script&lang=js&"
export * from "./gpeaHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports